import { Options, Vue } from "vue-class-component";
import { useToast } from "vue-toastification";

import Button from "@/components/button/button.vue";
import Checkbox from "@/components/checkbox/checkbox.vue";
import Input from "@/components/input/input.vue";
import { CredentialService } from "@/services/credentials.service";

@Options({
  components: {
    "app-checkbox": Checkbox,
    "app-input": Input,
    "app-button": Button,
  },
})
export default class Login extends Vue {
  private appElement: HTMLElement | null = null;
  public accessKey: string = "";
  public secretKey: string = "";
  public rememberMe: boolean = false;
  public isAuthLoading: boolean = false;
  private toast = useToast();

  public mounted(): void {
    this.appElement = document.getElementById("app") as HTMLElement;
    this.appElement.classList.add("login-page");
  }

  public unmounted(): void {
    (this.appElement as HTMLElement).classList.remove("login-page");
  }

  public async login(): Promise<void> {
    try {
      this.isAuthLoading = true;

      const loginResult = await CredentialService.login(this.accessKey, this.secretKey);

      this.$store.dispatch("auth/login", loginResult);
      this.toast.success("Login realizado.");
      this.isAuthLoading = false;
    } catch (error) {
      const message = error?.response?.data?.message || error.message || "Failed";
      console.error(message);
      this.toast.error("Login ou senha inválidos.");
      this.isAuthLoading = false;
    }
  }
}
